
// rms-step/rms-step.component.ts
import { Component, Input, TemplateRef, ViewChild } from '@angular/core';
import { AbstractControl } from '@angular/forms';

@Component({
  selector: 'rms-step',
  standalone: true,
  template: `
    <ng-template><ng-content></ng-content></ng-template>
  `
})
export class RmsStepComponent {
  /** Primary label shown in the header and legend */
  @Input() label: string = '';

  /** Optional subtitle below the main label in the header */
  @Input() subtitle?: string;

  /** Marks this step as optional for linear validation */
  @Input() optional: boolean = false;

  /** Allow clicking header to navigate in non-linear mode (per-step override) */
  @Input() editable: boolean = true;

  /** Supply a control/group; used to determine validity in linear mode */
  @Input() stepControl?: AbstractControl | null;

  /** Manually flag completion state (used when no control is provided) */
  @Input() completed: boolean = false;

  /** Optional error text shown on invalid step header in linear mode */
  @Input() error?: string;

  @ViewChild(TemplateRef, { static: true }) template!: TemplateRef<any>;
}
